import { Link } from 'react-router-dom';
import { Calendar, MapPin, Sparkles } from 'lucide-react';
import SEO from '../../components/SEO';

export default function MoedOsHerEn() {
  const messePunkter = [
    'Enter our prize draw to win a Danshaker on free loan for 14 days',
    'Experience the Danshaker up close and test its build quality',
    'See all the modular accessories available for customization',
    'Witness live demonstrations of how the machine works in practice',
    'Discuss your stable facility requirements and potential solutions',
    'Book a free demo directly to your own stable',
    'Ask any technical or practical questions you might have'
  ];

  const eventsList = [
    {
      title: 'Hest og Rytter 2027',
      dates: 'March 11 – 14, 2027',
      locationName: 'Messecenter Herning, Denmark',
      locationDetail: 'Stand F5268',
      badge: 'Mar 11 - 14, 2027',
      description: 'Meet us at Hest og Rytter in Messecenter Herning, where we look forward to welcoming you and presenting our sorting machine and specialized accessories.'
    }
  ];

  return (
    <div className="relative min-h-screen bg-slate-50 text-slate-900 antialiased">
      <SEO
        title="Meet Us at Upcoming Events & Fairs - Hest og Rytter 2027"
        description="Meet Danshaker at major equestrian fairs like Hest og Rytter in Herning (March 11-14, 2027). Experience the sorting machine live on stand F5268 and explore our accessories."
        path="/en/meet-us"
        lang="en"
      />

      {/* Background gradients */}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(14,103,162,0.05),transparent_60%)]" />

      {/* Header Section */}
      <section className="mx-auto max-w-7xl px-4 pt-16 pb-12 md:px-8 md:pt-24">
        <div className="text-center max-w-3xl mx-auto space-y-4">
          <div className="inline-flex items-center gap-2 rounded-full bg-[#0E67A2]/10 px-4 py-1.5 text-xs font-bold text-[#0E67A2]">
            <Sparkles className="h-3.5 w-3.5" aria-hidden="true" />
            <span>Fairs & Trade Shows</span>
          </div>
          <h1 className="text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">
            Meet Us Here
          </h1>
          <p className="text-lg text-slate-600 leading-relaxed">
            We regularly attend leading equestrian fairs and industry events throughout the year. Come meet us, test the Danshaker in person, and chat about stable efficiency.
          </p>
        </div>
      </section>

      {/* Events List */}
      <section className="mx-auto max-w-5xl px-4 pb-12 md:px-8">
        <div className="space-y-8">
          {eventsList.map((evt, idx) => (
            <div
              key={idx}
              className="overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-xl transition hover:shadow-2xl"
            >
              <div className="grid gap-6 md:grid-cols-12 md:items-center p-6 md:p-10">
                <div className="md:col-span-8 space-y-4">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="inline-flex items-center gap-1.5 rounded-full bg-[#0E67A2] px-3.5 py-1 text-xs font-bold text-white shadow-xs">
                      <Calendar className="h-3.5 w-3.5" />
                      {evt.badge}
                    </span>
                    {evt.extraBadge && (
                      <span className="inline-flex items-center rounded-full bg-emerald-500/10 px-3.5 py-1 text-xs font-bold text-emerald-700 border border-emerald-500/20">
                        {evt.extraBadge}
                      </span>
                    )}
                  </div>

                  <h2 className="text-2xl font-black text-slate-900 sm:text-3xl">
                    {evt.title}
                  </h2>

                  <div className="flex flex-wrap items-center gap-y-2 gap-x-6 text-sm text-slate-600 font-medium">
                    <div className="flex items-center gap-2">
                      <MapPin className="h-4 w-4 text-[#0E67A2] shrink-0" />
                      <span>{evt.locationName}</span>
                    </div>
                    <div className="rounded-md bg-slate-100 px-2.5 py-1 font-semibold text-slate-700">
                      {evt.locationDetail}
                    </div>
                  </div>

                  <p className="text-slate-600 leading-relaxed font-medium pt-2">
                    {evt.description}
                  </p>
                </div>

                <div className="md:col-span-4 flex flex-col items-stretch sm:items-start md:items-end justify-center border-t md:border-t-0 md:border-l border-slate-100 pt-6 md:pt-0 md:pl-8 space-y-3">
                  <Link
                    to="/en/free-demo"
                    className="w-full text-center rounded-xl bg-[#0E67A2] px-6 py-3.5 text-sm font-bold text-white shadow-md transition hover:bg-[#0E67A2]/90"
                  >
                    Book free demo now
                  </Link>
                  <Link
                    to="/en/contact"
                    className="w-full text-center rounded-xl border border-slate-200 bg-white px-6 py-3.5 text-sm font-bold text-slate-700 shadow-xs transition hover:bg-slate-50"
                  >
                    Contact us
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* What to experience at our booth */}
      <section className="mx-auto max-w-5xl px-4 py-12 md:px-8">
        <div className="rounded-3xl border border-slate-200 bg-white p-8 md:p-12 shadow-xl space-y-8">
          <div className="text-center max-w-2xl mx-auto space-y-2">
            <h2 className="text-2xl font-extrabold text-slate-900 sm:text-3xl">
              At our fair stand, you can:
            </h2>
            <p className="text-sm text-slate-600 font-medium">
              We look forward to giving you an inspiring and informative experience.
            </p>
          </div>

          <div className="grid gap-4 sm:grid-cols-2">
            {messePunkter.map((punkt, idx) => (
              <div
                key={idx}
                className="flex items-start gap-3.5 rounded-2xl bg-slate-50 p-4 border border-slate-100"
              >
                <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#0E67A2]/10 text-[#0E67A2] font-black text-xs mt-0.5">
                  ✓
                </div>
                <span className="text-sm font-semibold text-slate-800 leading-snug">{punkt}</span>
              </div>
            ))}
          </div>

          <div className="text-center pt-4">
            <p className="text-sm font-bold text-slate-900 mb-4">
              Can’t wait for the fair? Try the machine in your own stable today.
            </p>
            <Link
              to="/en/free-demo"
              className="inline-flex items-center gap-2 rounded-xl bg-[#0E67A2] px-8 py-3.5 text-sm font-bold text-white shadow-md transition hover:bg-[#0E67A2]/90"
            >
              <Calendar className="h-4 w-4" />
              Book free demo directly
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
